import { useState } from "react";
import { useBilling } from "@/context/BillingContext";
import PlanCard from "@/pricing/PlanCard";
import FreePlanCard from "@/pricing/FreePlanCard";
import PricingIntervalToggle from "@/pricing/PricingIntervalToggle";
import PreviewDialog from "@/pricing/PreviewDialog";
import { useBillingActions } from "@/hooks/useBillingActions";

function PricingHero({ interval, onChange }) {
  return (
    <div className="text-center max-w-2xl mx-auto">
      <div className="text-xs uppercase tracking-widest text-stone-500">Plans</div>
      <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tighter text-stone-900 mt-1">
        One vault. Every trip.
      </h1>
      <p className="text-stone-600 mt-2">
        Start free, go Pro when your travel plans expand.
      </p>
      <PricingIntervalToggle interval={interval} onChange={onChange} />
    </div>
  );
}

function formatDate(iso) {
  return iso ? new Date(iso).toLocaleDateString() : null;
}

export default function Pricing() {
  const { plan, isPaid, tier, refresh } = useBilling();
  const [interval, setInterval] = useState("month");
  const actions = useBillingActions(refresh);

  const isAnnual = interval === "year";
  const cardProps = {
    isAnnual, isPaid, tier, plan,
    busy: actions.busy,
    managing: actions.managing,
    trialEnd: formatDate(plan?.trial_end),
    periodEnd: formatDate(plan?.current_period_end),
    onCheckout: actions.startCheckout,
    onPreview: actions.openPreview,
    onPortal: actions.openPortal,
  };

  return (
    <div className="space-y-10" data-testid="pricing-page">
      <PricingHero interval={interval} onChange={setInterval} />

      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto items-start">
        <FreePlanCard isAnnual={isAnnual} isPaid={isPaid} />
        <PlanCard planKey="pro" {...cardProps} />
        <PlanCard planKey="family" {...cardProps} />
      </div>

      <div className="text-center text-xs text-stone-500">
        Payments handled securely by Stripe · Cancel anytime from Manage billing
      </div>

      <PreviewDialog
        preview={actions.preview}
        confirming={actions.confirming}
        onConfirm={actions.confirmChange}
        onClose={actions.closePreview}
      />
    </div>
  );
}
